module.exports = __webpack_public_path__ + "static/img/xfftz.6122325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xfftz.jpg
// module id = ilou
// module chunks = 21